import type { ReactNode } from "react"

import { ImpersonationBanner } from "@/components/impersonation-banner"
import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"
import { RouterProvider } from "@/providers/RouterProvider"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  return (
    <RouterProvider>
      <ImpersonationBanner />
      {children}
      <Toaster richColors />
    </RouterProvider>
  )
}
